export default __webpack_public_path__ + "static/media/teamSpirit.e886cf89.svg";